export default {
    PARTICULAR: 1,  
    CONVENIO: 2,
}

  